import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { map, Observable, of, tap } from 'rxjs';
import { SelectEmpresaComponent } from 'src/app/modules/empresa/pages/select-empresa/select-empresa.component';
import { AuthStore } from 'src/app/services/auth.store';
import { EmpresaService } from 'src/app/services/empresa/empresa.service';
import { Usuario } from 'src/app/models/usuario';

@Component({
  selector: 'app-layout-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderLayoutComponent implements OnInit {
  nome$: Observable<string> = of('');
  empresaName$: Observable<string> = of('');

  constructor(
    private authStore: AuthStore,
    private empresaService: EmpresaService,
    private route: Router,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {
    if (this.authStore.isAdmin()) {
      this.nome$ = this.authStore.userAdmin$.pipe(map((res) => res.nome));
    } else {
      this.nome$ = this.authStore.userGestor$.pipe(map((res) => res.nome));
    }
    this.empresaName$ = this.empresaService
      .getEmpresaSelect()
      .pipe(map((res) => res.nome));
  }

  async sendTo() {
    const modal = await this.modalCtrl.create({
      component: SelectEmpresaComponent,
      cssClass: 'config-default',
      backdropDismiss: false,
    });
    modal.present();
    // this.route.navigate(['empresa','select'])
  }
}
